import { render, staticRenderFns } from "./Gallery.vue?vue&type=template&id=28e1cbc1&scoped=true"
import script from "./Gallery.vue?vue&type=script&lang=js"
export * from "./Gallery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e1cbc1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/050/050admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28e1cbc1')) {
      api.createRecord('28e1cbc1', component.options)
    } else {
      api.reload('28e1cbc1', component.options)
    }
    module.hot.accept("./Gallery.vue?vue&type=template&id=28e1cbc1&scoped=true", function () {
      api.rerender('28e1cbc1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/store/components/Gallery.vue"
export default component.exports